import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PartnerHero from './components/PartnerHero';
import PartnerBenefits from './components/PartnerBenefits';
import PartnerTiers from './components/PartnerTiers';
import HowItWorksStrip from './components/HowItWorksStrip';
import MamaPreferredSection from './components/MamaPreferredSection';
import PartnerApplyForm from './components/PartnerApplyForm';
import KeepExploring from '../../components/feature/KeepExploring';
import SEO from '../../components/feature/SEO';

export default function PartnerPage() {
  const [showForm, setShowForm] = useState(false);
  const siteUrl = import.meta.env.VITE_SITE_URL ?? '';

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Partner With The Mommy Mingle | Reach Gwinnett Moms"
        description="Get your business in front of thousands of local moms in Gwinnett and surrounding counties. Apply to become a Featured Partner, Mama Approved listing, or Event Sponsor."
        keywords="partner with mom community Gwinnett, advertise to local moms Georgia, business visibility Gwinnett County, local business marketing"
        canonical="/partner"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Partner With The Mommy Mingle | Reach Gwinnett Moms',
          description: 'Get your business in front of thousands of local moms in Gwinnett and surrounding counties.',
          url: `${siteUrl}/partner`,
          publisher: { '@type': 'Organization', name: 'The Mommy Mingle', url: siteUrl },
        }}
      />
      <Navbar />
      <PartnerHero onApply={() => setShowForm(true)} />
      <HowItWorksStrip />
      <PartnerBenefits />
      <PartnerTiers onApply={() => setShowForm(true)} />
      <MamaPreferredSection onApply={() => setShowForm(true)} />
      <KeepExploring
        title="See Where Your Business Gets Featured"
        subtitle="Explore the Mama Approved directory and Events to see how partners show up across the platform."
        items={[
          { label: 'View Mama Approved Directory', icon: 'ri-medal-line', to: '/mama-approved' },
          { label: 'Browse Local Events', icon: 'ri-calendar-event-line', to: '/events' },
          { label: 'Apply to Partner', icon: 'ri-handshake-line', to: '/partner', primary: true },
        ]}
        bg="white"
      />
      {showForm && <PartnerApplyForm onClose={() => setShowForm(false)} />}
      <Footer />
    </div>
  );
}
